import React from "react";
import { SanityTechnicalContentSpecItem } from "@sourceful/shared-types";
import { styled } from "@sourceful/shared-components";
import { getImageDimensions, getSanityImgUrl } from "@lib/sanity";
import ProductFeaturesList from "../../../views/productDetailPage/productFeatures/ProductFeaturesList";
import { IMAGE_DIMENSION_HALF_SECTION_WIDTH } from "@lib/utils/imageDimensions";

const TechnicalContentSpecItemContainer = styled("div", {
  display: "block",
  padding: "20px 0 40px 0",

  "@sm": {
    alignItems: "flex-start",
    display: "flex",
  },
});

const SpecImage = styled("img", {
  width: "100%",
  height: "auto",
  marginRight: "40px",

  "@sm": {
    width: "300px",
    maxWidth: "100%",
  },
});

interface TechnicalContentSpecItemProps {
  item: SanityTechnicalContentSpecItem;
}

const TechnicalContentSpecItem = ({ item }: TechnicalContentSpecItemProps) => {
  const imageDimensions = getImageDimensions(item?.image?.asset._ref);

  return (
    <TechnicalContentSpecItemContainer>
      {item?.image && item?.image?.asset && (
        <SpecImage
          loading="lazy"
          src={
            item?.image
              ? getSanityImgUrl(item?.image?.asset?._ref || "", base =>
                  base.width(IMAGE_DIMENSION_HALF_SECTION_WIDTH)
                )
              : ""
          }
          alt={item?.image?.asset?.altText}
          width={imageDimensions?.width.toString() || "100%"}
          height={imageDimensions?.height.toString() || "auto"}
        />
      )}
      <div>
        <ProductFeaturesList
          features={item?.productFeatures}
          backgroundTheme="grey"
          iconTheme={item?.colour?.value}
          colorOverride={item?.colour ? `${item?.colour?.value}` : ""}
        />
      </div>
    </TechnicalContentSpecItemContainer>
  );
};

export default TechnicalContentSpecItem;
